<ep-auth-container
  [imageSrc]="
    (subdomainType$ | async) === SubdomainTypes.EagleProcessing
      ? '../../../assets/eagle-logo.png'
      : '../../../assets/enroll-and-pay-logo.png'
  "
>
  <app-loading-spinner
    *ngIf="isLoading$ | async"
    [message]="'Loading...'"
    class="text-center loading-spinner"
  ></app-loading-spinner>
</ep-auth-container>
